import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Divider, Icon, Menu, MenuItem, Typography } from '@mui/material';
import { styles } from '../Styles';
import '../Styles.css'
import { CONST_SITE_LABEL } from '../Helper';
import { CONST_ROUTE_PATH } from '../../../route/RouteConstants';
import { RiAccountCircleFill } from "react-icons/ri";
import { useAuth } from '../../../state/AuthContext';
import { HiBars4 } from "react-icons/hi2";
import DebugService from '../../../services/DebugService';

export const MenuWithNestedMenu = ({
  menuLabel,
  nestedMenuList
}) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate()

  const goTo = (path) => {
    if (path !== undefined || path !== '') {
      navigate(path)
    }
  }

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={styles.button2}
        color="inherit"
      >
        {menuLabel}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        style={{
          padding: '0'
        }}
      >
        {nestedMenuList.map((m, i) =>
        (
          <MenuItem key={i} onClick={() => goTo(m.path)}>
            <Typography variant='body2' style={styles.homeSubMenu}>{m.label}</Typography>
          </MenuItem>
        )
        )}
      </Menu>
    </>
  )
}

export const ShowDashboardMenu = () => {

  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const {
    isOnboarded,
    logout,
    isSubscriptionActive,
    loadingUserDetails,
    loggedIn,
    accountList,
    selectedAccount,
  } = useAuth()

  const navigate = useNavigate()

  const handleDashboardNavigation = () => {
    // if (accountList.length > 0) {

    // } else {
    //   DebugService.warn(`ShowDashboardMenu Component: No account list found`, accountList)
    //   navigate(CONST_ROUTE_PATH.PRICING)
    // }

    if (loadingUserDetails === false && isSubscriptionActive === false && isOnboarded) {
      navigate(CONST_ROUTE_PATH.PRICING)
    } else {
      navigate(CONST_ROUTE_PATH.DASHBOARD)
    }
  }

  return (
    <>
      {loggedIn ? (
        <>
          <RiAccountCircleFill
            data-testid='dashboard-icon'
            title='Dashboard'
            fontSize="xx-large"
            aria-controls="user-menu"
            onClick={($e) => {
              setAnchorEl3($e.currentTarget);
            }}
            style={{
              verticalAlign: 'middle',
              cursor: 'pointer'
            }} />
          <Menu
            data-testid='dashboard-menu'
            className='account-menu'
            id="user-menu"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            // keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            anchorEl={anchorEl3}
            open={Boolean(anchorEl3)}
            onClose={() => setAnchorEl3(false)}
          >
            <MenuItem
              data-testid='dashboard-submenu'
              onClick={() => handleDashboardNavigation()}
            >Dashboard</MenuItem>
            <MenuItem
              className='menu-hover'
              onClick={() => {
                logout()
                navigate(CONST_ROUTE_PATH.SIGN_IN)
              }}
            >Logout</MenuItem>
          </Menu>
        </>
      ) : (
        <Button
          data-testid='try-now-btn'
          component={Link}
          to={CONST_ROUTE_PATH.SIGN_UP}
          variant='outlined'
          style={{
            borderRadius: '8px',
            background: '#FF9A00',
            color: '#fff'
          }}>
          Sign Up
          {/* <img className='arrow' src="/menu-icons/arrow.svg" alt="Arrow Icon" width="12" height="14" /> */}
        </Button>
      )}
    </>
  )
}


const TopBar = (props) => {
  // const productSubMenu = [
  //   { label: 'AWS FinOps Tool', path: '/sign-up' },
  // ];

  const [barMenuAnchorEl, setBarMenuAnchorEl] = React.useState(null);

  const showCollapsedMenu = Boolean(barMenuAnchorEl);
  const handleClickBarMenu = (event) => {
    setBarMenuAnchorEl(event.currentTarget);
  };

  useEffect(() => {

  }, [])

  return (
    <>
      <Box>
        <AppBar
          // position="fixed"
          style={{
            backgroundColor: "#012A4A",
            color: '#fff',
            boxShadow: 'unset',
            position: 'relative',
            borderRadius: 'none'
          }}
        >
          <Toolbar sx={{
            justifyContent: 'space-between'
          }}>
            <Link title='Home' to={process.env.REACT_APP_BUSINESS_WEBSITE_HOST} className='home-logo'>
              <img src={`/${CONST_SITE_LABEL}-logo.png`} alt={CONST_SITE_LABEL} style={{
                width: '100px'
              }} />
            </Link>

            <div className='collapsed-home-menus'>
              <Icon
                id="bar-menu-icon-id"
                aria-controls={showCollapsedMenu ? 'bar-menu-icon' : undefined}
                aria-haspopup="true"
                aria-expanded={showCollapsedMenu ? 'true' : undefined}
                onClick={handleClickBarMenu}
              >
                <HiBars4 />
              </Icon>
              <Menu
                id="bar-menu-icon"
                anchorEl={barMenuAnchorEl}
                open={showCollapsedMenu}
                onClose={() => setBarMenuAnchorEl(null)}
                MenuListProps={{
                  'aria-labelledby': 'bar-menu-icon-id',
                }}
                sx={{
                  "& .MuiPaper-root": {  // Targeting the dropdown container
                    backgroundColor: "#2793F2",
                    color: "#fff",
                  },
                }}
              >
                <MenuItem ><ShowDashboardMenu /></MenuItem>
                <Divider style={{ backgroundColor: '#fff' }} />
                {/* <MenuItem className='collapsed-menu-item'>
              <Button style={{color: '#fff'}} component={Link} to={CONST_ROUTE_PATH.ABOUT}>
                About
              </Button>
            </MenuItem>
            <MenuItem style={{color: '#fff'}}>
              <MenuWithNestedMenu menuLabel={'Products'} nestedMenuList={productSubMenu} />
            </MenuItem>
            <MenuItem style={{color: '#fff'}}>
              <MenuWithNestedMenu menuLabel={'Services'} nestedMenuList={MENU_SERVICE_LIST} />
            </MenuItem> */}
                {/* <MenuItem style={{ color: '#fff' }}>
                  <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.PRICING} color="inherit">
                    Pricing
                  </Button>
                </MenuItem> */}
                {/* <MenuItem>
                  <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.CLOUD_ESTIMATOR} color="inherit">
                    Cloud Estimator
                  </Button>
                </MenuItem> */}
                {/* <MenuItem style={{color: '#fff'}}>
              <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.CONTACT_US} color="inherit">
                Contact us
              </Button>
            </MenuItem> */}
              </Menu>
            </div>

            <div className='expanded-home-menus'>
              {/* <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.ABOUT} color="inherit">
            About
          </Button> */}

              {/* Products */}
              {/* <MenuWithNestedMenu menuLabel={'Products'} nestedMenuList={productSubMenu} /> */}

              {/* Services */}
              {/* <MenuWithNestedMenu menuLabel={'Services'} nestedMenuList={MENU_SERVICE_LIST} /> */}

              {/* <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.PRICING} color="inherit">
                Pricing
              </Button> */}
              {/* <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.CLOUD_ESTIMATOR} color="inherit">
                Cloud Estimator
              </Button> */}
              {/* <Button sx={styles.button2} component={Link} to={CONST_ROUTE_PATH.CONTACT_US} color="inherit">
            Contact us
          </Button> */}

              <ShowDashboardMenu />
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default TopBar;
